import { ScrollReveal } from '@/components/ui/ScrollReveal';
import { Button } from '@/components/ui/button';
import { LocalizedLink } from '@/components/LocalizedLink';
import { useTranslation } from 'react-i18next';

export const Experience = () => {
  const { t } = useTranslation(['home', 'common']);

  return (
    <section className="bg-background py-32 px-6" aria-labelledby="experience-heading">
      <div className="mx-auto max-w-7xl">
        <div className="grid gap-16 lg:grid-cols-2 lg:gap-24 items-center">
          <div className="order-2 lg:order-1">
            <ScrollReveal>
              <span className="mb-4 inline-block text-sm font-light uppercase tracking-[0.3em] text-primary">
                {t('home:experience.menuExperience')}
              </span>
            </ScrollReveal>

            <ScrollReveal delay={100}>
              <h2 id="experience-heading" className="mb-8 text-4xl font-semibold text-foreground md:text-5xl">
                {t('home:experience.line1')}
                <br />
                <span className="text-primary">{t('home:experience.line2')}</span>
              </h2>
            </ScrollReveal>

            <ScrollReveal delay={200}>
              <p className="mb-6 text-lg font-light text-muted-foreground">{t('home:experience.text1')}</p>
            </ScrollReveal>

            <ScrollReveal delay={300}>
              <p className="mb-10 text-lg font-light text-muted-foreground">{t('home:experience.text2')}</p>
            </ScrollReveal>

            <ScrollReveal delay={400}>
              <div className="flex flex-wrap gap-4">
                <Button variant="outline" size="lg" asChild>
                  <LocalizedLink href="/menu">{t('common:cta.discoverMenu')}</LocalizedLink>
                </Button>
                <Button variant="ghost" size="lg" className="underline-hover" asChild>
                  <LocalizedLink href="/corean-experience">{t('home:experience.experiences')}</LocalizedLink>
                </Button>
              </div>
            </ScrollReveal>
          </div>

          <ScrollReveal className="order-1 lg:order-2">
            <div className="relative overflow-hidden">
              <img
                src="/img/DSC09190 (2024-04-22T17_54_40.682).JPG"
                alt={t('home:experience.imageAlt')}
                className="w-full object-cover aspect-square"
                loading="lazy"
                decoding="async"
                width="800"
                height="800"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background/40 to-transparent" />
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
};
